export const $StickyActionsModuleName = "stickyActions";

export type TStickyActionsState = {
    references: number;
};
